import { useState } from 'react'
import { Button, Input, Radio } from 'antd'

export type DelayOutcome = 'resolved' | 'not_resolved'

interface Props {
    loading: boolean
    onConfirm: (comment: string, outcome: DelayOutcome) => void
    onCancel: () => void
}

/**
 * Inline resolve form for a single delay row.
 *
 * The comment lives in LOCAL React state (not the MobX store) on purpose: each
 * keystroke must re-render only this small form, not the whole TaskDelaysCell
 * antd Table. Keeping it observable caused visible typing lag (BUG-5).
 */
export const DelayResolveForm = ({ loading, onConfirm, onCancel }: Props) => {
    const [comment, setComment] = useState('')
    const [outcome, setOutcome] = useState<DelayOutcome>('resolved')

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
            <Radio.Group
                size="small"
                value={outcome}
                onChange={(e) => setOutcome(e.target.value as DelayOutcome)}
            >
                <Radio value="resolved">Вирішено</Radio>
                <Radio value="not_resolved">Не вирішено</Radio>
            </Radio.Group>
            <Input.TextArea
                rows={2}
                placeholder="Коментар диспетчера (обов'язково)"
                value={comment}
                onChange={(e) => setComment(e.target.value)}
                style={{ fontSize: 12 }}
            />
            <div style={{ display: 'flex', gap: 4 }}>
                <Button
                    size="small"
                    type="primary"
                    loading={loading}
                    onClick={() => onConfirm(comment, outcome)}
                >
                    Підтвердити
                </Button>
                <Button size="small" onClick={onCancel}>
                    Скасувати
                </Button>
            </div>
        </div>
    )
}
